export default __webpack_public_path__ + "c5b5968e3b88e0dce349d6c403129c2e.png";